/**
 * Product detail SEO description for prerender + Helmet.
 *
 * Source of truth: products.short_description (explicit). If missing, a
 * deterministic product-specific fallback from name/price — never homepage copy.
 *
 * The explicit branch keeps the existing ProductDetailPage DOM-write formula
 * so pages that already prerender correctly (e.g. d-b-xsl8) stay unchanged.
 */

export const HOMEPAGE_SHELL_DESCRIPTION =
  'Hyr professionell festutrustning i Skåne. Ljud, ljus och DJ-utrustning för alla tillfällen. Leverans inom 10 mil från Malmö. Perfekt för bröllop, student och företagsevent.';

export type ProductSeoInput = {
  name: string;
  slug?: string | null;
  shortDescription?: string | null;
  priceOnRequest?: boolean;
  pricePerDay?: number | null;
};

export function resolveProductDocumentTitle(product: ProductSeoInput): string {
  return `${product.name} - Hyra festutrustning | festutrustning.se`;
}

export function resolveProductSeoDescription(product: ProductSeoInput): string {
  const explicit = (product.shortDescription || '').trim();
  if (explicit) {
    return product.priceOnRequest
      ? `Begär offert för ${product.name}. ${explicit} Professionell festutrustning i Skåne med leverans. Offert inom 24 timmar.`
      : `Hyr ${product.name} för ${product.pricePerDay} kr/dag. ${explicit} Professionell festutrustning i Skåne med leverans.`;
  }

  return product.priceOnRequest
    ? `Begär offert för ${product.name}. Professionell festutrustning i Skåne med leverans.`
    : `Hyr ${product.name} för ${product.pricePerDay} kr/dag. Professionell festutrustning i Skåne med leverans.`;
}

/** Apply description to the existing shell/Helmet meta tag so prerender sees it before ready. */
export function applyProductMetaDescriptionToDocument(description: string): void {
  if (typeof document === 'undefined' || !description) return;
  const meta = document.querySelector('meta[name="description"]');
  if (meta) {
    meta.setAttribute('content', description);
  }
}

/** Sync title + description into the document before prerenderReady. */
export function applyProductSeoMetaToDocument(product: ProductSeoInput): void {
  if (typeof document === 'undefined') return;
  document.title = resolveProductDocumentTitle(product);
  applyProductMetaDescriptionToDocument(resolveProductSeoDescription(product));
}
